const zhCommon = {
  'site.name': '西瓜视频',
  'site.slogan': '高清免费在线播放平台',
  'site.description': '西瓜视频提供蜜桃视频、红桃视频、樱桃视频等高清在线播放，无需下载插件，手机电脑网页直接观看，流畅不缓冲。',
  'nav.home': '首页',
  'nav.category': '分类',
  'nav.about': '关于我们',
  'nav.search': '搜索视频...',
  'nav.searchPlaceholder': '输入关键词搜索...',
  'footer.copyright': '© 2026 西瓜视频 版权所有',
  'footer.about': '关于我们',
  'footer.terms': '服务条款',
  'footer.privacy': '隐私政策',
  'footer.contact': '联系我们',
  'footer.description': '西瓜视频是一个领先的在线高清视频平台，提供蜜桃视频、红桃视频、樱桃视频等丰富的内容分类。无需下载任何插件，手机电脑直接在线观看，流畅不缓冲。',
  'breadcrumb.home': '首页',
  'button.viewAll': '查看全部',
  'button.readMore': '阅读全文',
  'button.watchNow': '立即观看',
  'label.views': '次播放',
  'label.duration': '时长',
  'label.rating': '评分',
  'label.publishDate': '发布时间',
  'label.author': '作者',
  'label.category': '分类',
  'label.tags': '标签',
};

export default zhCommon;